<template>
  <el-dialog :visible.sync="completedApplicationVisible" :show-close="false">
    <div class="completed-application-border">
      <!-- 上面的 -->
      <div class="back" @click="closeCompletedApplication">
          <i class="el-icon-arrow-left"></i>
          Back
      </div>
      <template>
        <div class="content"><h4>Please complete the Net Terms application on the new page you open</h4></div>
        <div class="btns">
          <div class="btn" @click="check" v-loading="diaLoading">Completed application</div>
        </div>
      </template>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      diaLoading: false,
      completedApplicationVisible: true,
      disabled: false
    }
  },
  methods: {
    /**
     * 将该按钮设置
     */
    check() {
      if (this.diaLoading) {
        // 如果是true的话，则不调用后台
        return
      }
      this.diaLoading = true
      // 然后调用父组件查询状态
      this.$emit('queryStatus')
    },
    closeCompletedApplication() {
      this.$emit('closeCompletedApplication')
    },
    /**
     * 将当前的弹框关闭，并且取消加载状态
     */
    closeCurrentDialog() {
      this.diaLoading = false
    }
  }
}
</script>

<style lang="less" scoped>
.completed-application-border{
  position: fixed;
  padding: 30px;
  width: 600px;
  left: 50%;
  top: 130px;
  margin-left: -300px;
  z-index: 100;
  background: #FFFFFF;
  border: 1px solid #E1E1E1;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.05);
  .back{
      display: flex;
      align-items: center;
      font-size: 18px;
      cursor: pointer;
  }
  .content{
    margin-top: 20px;
    text-align: center;
  }
  .btns{
      display: flex;
      justify-content: center;
      margin-top: 30px;
      .btn{
          display: flex;
          justify-content: center;
          align-items: center;
          background: #262B2F;
          width: 50%;
          height: 50px;
          border-radius: 5px;
          font-size: 14px;
          font-family: Graphik;
          font-weight: normal;
          color: #FFFFFF;
          cursor: pointer;
      }
  }
}
@media screen and (max-width: 420px) {
  .completed-application-border{width: 330px;left: 75%;}
}
@media screen and (max-width: 380px) {
  .completed-application-border{width: 300px;left: 82%;}
}
</style>



// WEBPACK FOOTER //
// src/pages/credit-payment/completedApplication.vue